import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Actions, Store } from '@ngxs/store';
import { handleErrorsUntilSignedOutOnError } from '@platform-frontend/account';
import { PLATFORM_STARTUP_ERROR_HANDLERS } from '@platform-frontend/platform';
import { SimpleRouterState } from '@platform-frontend/util';
import { CheckoutStandaloneService } from '../standalone/checkout-standalone.service';
import { WebCheckoutIntegrationService } from '../web-checkout-integration.service';

export const EmptyGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const integrationMode = inject(WebCheckoutIntegrationService).getIntegrationMode();
  const store = inject(Store);
  const location = inject(Location);
  const checkoutStandaloneService = inject(CheckoutStandaloneService);
  const actions$ = inject(Actions);
  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    if (route.data.goBack) {
      /**
       * Navigate forward and then immediately back, permanently
       * blocking the user from navigating forward to this route.
       */
      Promise.resolve().then(() => location.back());
    } else if (integrationMode === 'standalone') {
      checkoutStandaloneService
        .handleStartupQueryParams(route.queryParamMap)
        .pipe(handleErrorsUntilSignedOutOnError(actions$, PLATFORM_STARTUP_ERROR_HANDLERS))
        .subscribe();
    }
  }
  return true;
};
